import React from 'react';

import styles from './HomeOpportunitiesSection.module.scss';

export default function HomeOpportunitiesSection() {
  return (
    <div className={styles.opportunitiesSection}>
      <div className="container">
        <div className="lending-title">
          Join Hundreds of Talent Teams Across the Globe:
        </div>
        <div className={styles.itemRow}>
          <div className={styles.itemCol}>
            <div className={styles.itemContent}>
              <div className={styles.itemIconWrapper}>
                <span className="icon icon-team"></span>
              </div>
              <div className={styles.itemText}>
                Our Talent Acquisition Marketplace is used by talent acquisition
                teams from leading organizations
              </div>
            </div>
          </div>
          <div className={styles.itemCol}>
            <div className={styles.itemContent}>
              <div className={styles.itemIconWrapper}>
                <span className="icon icon-book"></span>
              </div>
              <div className={styles.itemText}>
                Access to exclusive job requisitions
              </div>
            </div>
          </div>
          <div className={styles.itemCol}>
            <div className={styles.itemContent}>
              <div className={styles.itemIconWrapper}>
                <span className="icon icon-growth"></span>
              </div>
              <div className={styles.itemText}>
                Grow your portfolio by delivering on new opportunities
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
